import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchBrandDropdown(app, params) {
  const { searchTerm, searchParams, fields=['id', 'name', 'short_name'], id } = params;
  const dropdown_type = 'brand/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveBrand(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const brandData = {
    doc_type: DocType.BRAND,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    system_defined: util.toBoolean(data.system_defined),
  };
  return common.saveDoc(app, {
    source: data,
    doc: brandData,
    user,
  });
}

export function deleteBrand(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.BRAND
  });
}

export function fetchBrandById(app, params) {
  const { id } = params;
  const docType = DocType.BRAND;
  return common.getDoc(app, { id, docType });
}
